const Colors = {
    brand: {
        cobalt: '#003566',
        midnight: '#002A51',
        midnightTopGradient: '#003a85',
        electric: '#005FB7',
        cyan: '#08A4BD',
        slate: '#6E8894',
        slateLight: '#B0C4D4', // NEW: Lighter version of slate for description text in dark mode
        mint: '#B2F2D6',
        yellow: '#FFD60A',
        facebook: '#1877F2',
        new: '#264A6B',
        midnightLight: '#395983', // NEW: Lighter version of midnight for text and borders in dark mode
        electricLight: '#6CA0E0', // NEW: Lighter version of electric for text in dark mode
        successDark: '#395B4A', // NEW: Darker version of success for dark mode backgrounds
        errorDark: '#5A2A2A', // NEW: Darker version of error for dark mode backgrounds
    },
    chart: {
        cyan: '#52BCD1',
        electric: '#4D8FCD',
    },
    company: {
        paypal: '#FCBB32',
        paypal_blue: '#012169',
    },
    shades: {
        white: '#FFFFFF',
        shade100: '#F2F5F7',
        shade200: '#F8F8F8',
        shade300: '#EEEEEE',
        shade400: '#DAE1E4',
        shade500: '#4A4A4A',
        shade600: '#DBE9F5',
        black: '#111111',
        black_faded: 'rgba(0,0,0,0.25)',
        black_faded_heavy: 'rgba(0,0,0,0.5)',
        black_faded_super_heavy: 'rgba(0,0,0,0.9)',
        blackFadedHeavy: '#222831', // NEW: Slightly lighter black for headers/footers in dark mode
    },
    accents: {
        accent100: '#ADD7FF',
        accent200: '#7F9AB2',
    },
    highlights: {
        highlight100: '#620AFF',
        highlight100Faded: `rgba(98,10,255,0.4)`,
        highlight200: '#FCA311',
        highlight200Faded: 'rgba(252,163,17,0.4)',
        highlight300: '#FF4747',
        highlight300Faded: 'rgba(255,71,71,0.4)',
        highlight400: '#4DBA58',
        highlight400Faded: 'rgba(125,205,133,0.4)',
        highlight500: '#05A4BD',
        highlight500Faded: 'rgba(5,164,189,0.25)',
    },
    utility: {
        success: '#7DCD85',
        error: '#D5573B',
        warning: '#FCA311',
    },
    incentive: {
      gold: '#AB9F5E',
      gold_faded: 'rgba(171,159,94, 0.1)',
      silver: '#C0C0C0',
      bronze: '#997840',
      goldDark: '#8A7A4B', // NEW: Darker gold for dark mode
      silverDark: '#9A9A9A', // NEW: Muted silver for dark mode
      bronzeDark: '#7A5F30', // NEW: Deeper bronze for dark mode
  },
};

export default Colors